module.exports = "p {\n  font-size: 1.5rem; }\n"